var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogCard',{attrs:{"title":_vm.startCategory,"actions":_vm.actions}},[_c('v-text-field',{attrs:{"label":"Kategori"},model:{value:(_vm.topic_name),callback:function ($$v) {_vm.topic_name=$$v},expression:"topic_name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }